export var SDK_VERSION = '6.18.2';
//# sourceMappingURL=version.js.map